<header class="header-logo d-flex align-items-center justify-content-between">
  <img src="assets/images/headerIMG.png" alt="Logo Tarificador">

  <div class="header-content d-flex align-items-center justify-content-between flex-grow-1 ms-3">
    <h1 class="m-0">Tarificador</h1>

    <nav class="language-panel ms-auto" aria-label="Selector de idioma">
      <div class="dropdown">
        <button class="btn dropdown-toggle mx-2 mt-1 btn-sm languageButton" type="button" id="dropdownMenuButton"
          data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img [src]="flagMap[currentLanguage]" class="flag-icon" alt="Idioma actual">
          {{ 'header.' + currentLanguage | translate }}
        </button>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <button type="button" class="dropdown-item" (click)="changeLanguage('en')">
            <img src="assets/images/flags/united-kingdom.png" class="flag-icon" alt="English">
            {{ 'header.en' | translate }}
          </button>

          <button type="button" class="dropdown-item" (click)="changeLanguage('es')">
            <img src="assets/images/flags/spain.png" class="flag-icon" alt="Español">
            {{ 'header.es' | translate }}
          </button>

          <button type="button" class="dropdown-item" (click)="changeLanguage('ca')">
            <img src="assets/images/flags/catalonia.png" class="flag-icon" alt="Català">
            {{ 'header.ca' | translate }}
          </button>
        </div>

        @if(this.validUserAuthentication()) {
        <button type="submit" class="btn btn-sm custombutton mt-1" (click)="this.closeSession()">
          {{ 'header.close' | translate }}
        </button>
        }
      </div>
    </nav>
  </div>
</header>